var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-embed-wrapper"},[_c('p',[_vm._v(" If a window does not open click "),_c('a',{attrs:{"href":_vm.embedUrl},on:{"click":_vm.openMobileApp}},[_vm._v(" Here ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }